const user = {
	state: {
		uid: localStorage.getItem('uid') || '', // 101
		token: localStorage.getItem('token') || '', // 8f7b3139-ba7c-4964-b7cf-1fba502e5f04
		info: {
			mobile: null,
			id: null,
			money: null,
			score: null,
			isVIP: 0,
			vipEndTime: null,
			nickname: null,
			avatar: null,
			gender: 0,
			birthday: null,
			qq: null,
			wechat: null,
			weibo: null
		},
		likes: null
	},
	mutations: {
		'SET_UID': (state, uid) => {
        	state.uid = uid
        },
		'SET_TOKEN': (state, token) => {
        	state.token = token
        },
		'SET_INFO': (state, info) => {
        	state.info = info
        },
		// 'SET_MOBILE': (state, mobile) => {
        // 	state.info.mobile = mobile
        // },
		// 'SET_GENDER': (state, gender) => {
        // 	state.info.gender = gender
        // },
		// 'SET_NICKNAME': (state, nickname) => {
        // 	state.info.nickname = nickname
        // },
		// 'SET_AVATAR': (state, avatar) => {
        // 	state.info.avatar = avatar
        // },
		// 'SET_BIRTHDAY': (state, birthday) => {
        // 	state.info.birthday = birthday
        // }
    }
}

export default user


// WEBPACK FOOTER //
// ./src/store/modules/user.js